import type { Ref, RefCallback } from 'react'

import { type DndEngineHandlers, registerDndElementHandlers } from '../engine'

// A ref that returns a cleanup is never called with null in React 19; the
// null branch only satisfies the RefCallback type.
export function handlerRef(handlers: DndEngineHandlers): RefCallback<HTMLElement> {
    return node => (node === null ? undefined : registerDndElementHandlers(node, handlers))
}

// React 19 refs may return a cleanup; composing keeps the child's own ref
// working (object or callback) next to the handler registration.
export function composeRefs(own: RefCallback<HTMLElement>, childRef: Ref<HTMLElement> | undefined): RefCallback<HTMLElement> {
    if (childRef === undefined || childRef === null) return own
    return node => {
        const ownCleanup = own(node)
        if (typeof childRef === 'function') {
            const childCleanup = childRef(node)
            return () => {
                ownCleanup?.()
                if (typeof childCleanup === 'function') childCleanup()
                else childRef(null)
            }
        }
        childRef.current = node
        return () => {
            ownCleanup?.()
            childRef.current = null
        }
    }
}
